import {ActiveOrganisationKey} from "../../../core/constants/constants";

export function setActiveOrganisation(data) {
    localStorage.setItem(ActiveOrganisationKey, JSON.stringify(data))
}

export function getActiveOrganisation() {
    try {
        const activeOrganisation = JSON.parse(localStorage.getItem(ActiveOrganisationKey))
        if (!!activeOrganisation?.id) {
            return activeOrganisation
        }else{
            return null
        }
    } catch (error) {
        return null
    }


}